import React from 'react';
import { Link } from 'react-router-dom';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="eb-page" dir="rtl">
                    <div className="eb-content">
                        <div className="eb-icon">⚠️</div>
                        <h2 className="eb-title">مشکلی پیش آمد</h2>
                        <p className="eb-desc">این صفحه با خطا روبرو شد. لطفاً صفحه را بارگذاری مجدد کنید.</p>
                        <div className="eb-actions">
                            <button className="eb-btn eb-btn--reload" onClick={() => window.location.reload()}>
                                بارگذاری مجدد
                            </button>
                            <Link to="/" className="eb-btn eb-btn--home">
                                صفحه اصلی
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
